import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import prepareCategoryFilters from 'utils/family/prepareCategoryFilters';
import { numberToSortAlg } from 'utils/family/sortAlgMapping';
import composeCategoryPageParams from 'utils/routes/composeCategoryPageParams';
import getCategoryFilters from '../selector/getCategoryFilters';
import getCategoryPageNr from '../selector/getCategoryPageNr';
import getCategorySortBy from '../selector/getCategorySortBy';

const updateCategoryQueryStringOperation =
  (history: any) => (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const pageNr = getCategoryPageNr(store);
    const sortBy = getCategorySortBy(store);
    const filters = prepareCategoryFilters(getCategoryFilters(store));
    const queryString = composeCategoryPageParams(pageNr, numberToSortAlg(sortBy), filters);
    history.push(queryString);
  };

export default updateCategoryQueryStringOperation;
